import { render, staticRenderFns } from "./ManuimComp.vue?vue&type=template&id=276a2a35&scoped=true&"
import script from "./ManuimComp.vue?vue&type=script&lang=js&"
export * from "./ManuimComp.vue?vue&type=script&lang=js&"
import style0 from "./ManuimComp.vue?vue&type=style&index=0&id=276a2a35&prod&scoped=true&lang=css&"
import style1 from "./ManuimComp.vue?vue&type=style&index=1&id=276a2a35&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a2a35",
  null
  
)

export default component.exports